/**
 * @module lib/commercial/keytar/subscriber/template
 */
import tgamConfig from "config/tgam";
import { setUpModalView } from "lib/commercial/keytar/common/takeover";
import { setUpTeaserView } from "lib/commercial/keytar/common/teaser";
import Template, { BLOCKOUT_TYPES, shouldShowTeaserRendering } from "lib/commercial/keytar/Template";
import isNil from "lodash/isNil";

/** @type {String} */
const wallType = "hardPaywall";
let blockoutType = BLOCKOUT_TYPES.HEADER_NAV_ACCESSIBLE; // responsive modal displayed for all modes
let leaveSection = ["top-furniture-area"];
let appendClasses = ["header-nav"];

if (tgamConfig.meta.isStoryInteractivePage) {
  blockoutType = BLOCKOUT_TYPES.EVERYTHING;
  leaveSection = [];
  appendClasses = [];
}

const showTeaserRendering = shouldShowTeaserRendering();
if (showTeaserRendering) {
  blockoutType = BLOCKOUT_TYPES.PREVIEW;
}

const props = {
  blockoutType,
  darwinRenderKey: wallType,
  /**
   * @method render
   * @description Attempt to render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    let { darwinTemplate, viewType, paragraphs } = this.darwinRendering();

    if (isNil(viewType) && showTeaserRendering) {
      this.updateTeaserAnalytics(paragraphs);
      viewType = "teaser";
    }
    if (viewType === "teaser") {
      setUpTeaserView(wallType, darwinTemplate, paragraphs, this.parentContext.contentType);
    } else {
      setUpModalView(wallType, darwinTemplate, ["subscriber"], leaveSection, appendClasses);
    }
    return Promise.resolve(true);
  }
};

export default new Template(props);
